import React from 'react';
import { Box, Typography, Container } from '@mui/material';

function Appointments() {
    return (
        <Container maxWidth="lg" sx={{ py: 6 }}>
            <Box textAlign="center" mb={4}>
                <Typography
                    variant="h4"
                    component="h1"
                    sx={{
                        fontWeight: 'bold',
                        mb: 2,
                        fontFamily: '"Roboto", sans-serif',
                        letterSpacing: 1,
                    }}
                >
                    Book an Appointment
                </Typography>
                <Typography
                    variant="body1"
                    sx={{
                        color: 'text.secondary',
                        fontSize: '1.1rem',
                        maxWidth: '600px',
                        mx: 'auto',
                        mb: 4,
                    }}
                >
                    Schedule your appointment with Anthrasync using the calendar below.
                </Typography>
            </Box>

            <Box
                sx={{
                    width: '100%',
                    height: '600px',
                    border: 'none',
                    boxShadow: 3,
                    borderRadius: 2,
                    overflow: 'hidden',
                }}
            >
                <iframe
                    src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ0G3d7qWB_ZTGJ8OGjjCR4VpM6YQ6nBEzJ4YpMtueSJ_l4ApI5sy80wqrknyolLr_ndgqOYlxO4?gv=true"
                    style={{
                        border: '0',
                        width: '100%',
                        height: '100%',
                    }}
                    frameBorder="0"
                    title="Google Calendar Appointment Scheduling"
                    allowFullScreen
                />
            </Box>
        </Container>
    );
}

export default Appointments;
